<template>
  <div :class="classObj" class="app-wrapper">
    <div class="top">
      <div class="title">
        <!-- <img :src="$store.state.user.avatar" class="pic-top" alt="logo"> -->
        <router-link to="">新强</router-link>
      </div>
    </div>
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar class="sidebar-container"/>
    <div class="main-container">
      <navbar/>
      <app-main/>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
// import { timeFn } from '@/utils/timestamp'

export default {
  name: 'CompanyLayout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  data () {
    return {
    }
  },
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    device () {
      return this.$store.state.app.device
    },
    classObj () {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  mounted () {
    // setInterval(() => {
    //   // 当时间差大于1小时50分钟时，刷新token
    //   if (timeFn(getCookie('tokentime')) > 110) {
    //     store.dispatch('refreshToken', getCookie('companyid'))
    //   }
    // }, 1000 * 60)
  },
  methods: {
    handleClickOutside () {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style>
  .el-select-dropdown{
    background-color: #fff !important;
    border: 1px solid #e4e7ed !important;
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
    .top{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding-left: 20px;
      // background-color: #1f2d3d;
      background-image: linear-gradient(to right, #205CD6, #2A6EE2, #3E93F4, #489EF4);
      color: #fff;
      z-index: 100;
      .title{
        display: flex;
        align-items: center;
        .pic-top{
          width: 36px;
          height: 36px;
          margin-right: 10px;
          border-radius: 50%;;
          overflow: hidden;
        }
      }
    }
    .main-container{
      top: 60px;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/views/backstagemanage/layout/Layout.vue